import { useState } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Menu, Loader, pxToRem, Box, Button } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import * as yup from 'yup';
import { useRole } from 'app/domains/users';
import { Form, SubmitButton, TextField, TextAreaField } from 'shared/domains/forms';
import { useGetTeamDetails } from './useGetTeamDetails';
import { useUpdateTeam } from './useUpdateTeam';
import { useTeamRole } from '../../../../../teams/hooks/useTeamRole';
export function EditTeamButton(props) {
    var _a;
    const label = t({
        message: 'Edit team',
        comment: 'Edit team button label (screen readers)',
    });
    const headingLabel = t({
        message: 'Edit team details',
        comment: 'team profile: Edit team dropdown title',
    });
    const teamNameInputLabel = t({
        message: 'Team name',
        comment: 'team profile: Edit team dropdown, team name input label',
    });
    const teamDescriptionInputLabel = t({
        message: 'Description',
        comment: 'team profile: Edit team dropdown, team description input label',
    });
    const nameMessage = t({
        message: 'Name is required',
        comment: 'Error message when name is empty',
    });
    const updateTeamSchema = yup.object().shape({
        name: yup.string().required(nameMessage),
        description: yup.string(),
    });
    const { teamId } = props;
    const [open, setOpen] = useState(false);
    const role = useRole();
    const teamRole = useTeamRole(teamId);
    const canUpdateTeam = role.can('update:team') || teamRole.can('update:team');
    const { team, loading } = useGetTeamDetails(teamId);
    const { updateTeam } = useUpdateTeam(teamId);
    const initialValues = {
        name: (team === null || team === void 0 ? void 0 : team.name) || '',
        description: (_a = team === null || team === void 0 ? void 0 : team.description) !== null && _a !== void 0 ? _a : undefined,
    };
    if (!canUpdateTeam) {
        return null;
    }
    const handleSubmit = (values) => updateTeam(values).then(() => setOpen(false));
    return (<Menu.Root open={open} onClose={() => setOpen(!open)} minWidth={pxToRem(300)} maxWidth={pxToRem(300)} target={<Button aria-label={label} appearance="secondary" size="xs" disabled={loading} onClick={() => setOpen(!open)}>
          {loading ? <Loader /> : <Falcon icon="pen"/>}
          <Trans comment="team profile: Edit team button label">Edit</Trans>
        </Button>}>
      <Form onSubmit={handleSubmit} initialValues={initialValues} validationSchema={updateTeamSchema} enableReinitialize>
        <Menu.Header title={headingLabel}/>

        <Box flexDirection="column" p="md">
          <TextField name="name" label={teamNameInputLabel}/>
          <TextAreaField label={teamDescriptionInputLabel} name="description"/>
        </Box>

        <Menu.Footer>
          <SubmitButton $stretch size="small">
            <Trans comment="team profile edit dropdown: update button label">Update</Trans>
          </SubmitButton>
        </Menu.Footer>
      </Form>
    </Menu.Root>);
}
